"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var colorsV2_1 = __importDefault(require("../../../../assets/jss/colorsV2"));
var styles = function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return (0, core_1.makeStyles)({
        barContainer: {
            marginBottom: theme.spacing(1)
        },
        strengthBarTitleText: {
            fontWeight: 'bold',
            fontFamily: 'Roboto, sans-serif'
        },
        strengthBarWeaknessText: {
            fontWeight: 'bold',
            fontFamily: 'Roboto, sans-serif',
            fontSize: '14px'
        },
        strengthBarSpecificationText: {
            fontFamily: 'Roboto, sans-serif',
            fontSize: '14px'
        },
        strengthBarSpecificationBox: {
            display: 'flex',
            flexDirection: 'column',
            gridGap: '4px'
        },
        strong: {
            backgroundColor: (_a = colorsV2_1.default.commonColors.success) === null || _a === void 0 ? void 0 : _a.hex()
        },
        medium: {
            backgroundColor: (_b = colorsV2_1.default.commonColors.warning) === null || _b === void 0 ? void 0 : _b.hex()
        },
        weak: {
            backgroundColor: (_c = colorsV2_1.default.commonColors.error) === null || _c === void 0 ? void 0 : _c.hex()
        },
        noPassword: {
            backgroundColor: (_d = colorsV2_1.default.palette.neutralsN600) === null || _d === void 0 ? void 0 : _d.hex()
        },
        strongBar: {
            backgroundColor: (_e = colorsV2_1.default.commonColors.success) === null || _e === void 0 ? void 0 : _e.hex().getLowEmphasis()
        },
        mediumBar: {
            backgroundColor: (_f = colorsV2_1.default.commonColors.warning) === null || _f === void 0 ? void 0 : _f.hex().getLowEmphasis()
        },
        weakBar: {
            backgroundColor: (_g = colorsV2_1.default.commonColors.error) === null || _g === void 0 ? void 0 : _g.hex().getLowEmphasis()
        },
        noPasswordBar: {
            backgroundColor: (_h = colorsV2_1.default.palette.neutralsN600) === null || _h === void 0 ? void 0 : _h.hex().getLowEmphasis()
        },
        errorCheckbox: {
            color: (_j = colorsV2_1.default.commonColors.success) === null || _j === void 0 ? void 0 : _j.hex(),
            fontSize: '14px'
        },
        errorCheckboxUncheck: {
            fontSize: '14px'
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map